import _ from 'lodash';

export const normalize = (str: string | undefined) => _.startCase(_.toLower(str));
